// extracted by mini-css-extract-plugin
module.exports = {"root":"w_S9ou","payNow":"RdsYvN","top-divider":"_5hUQ2","topDivider":"_5hUQ2"};